import { render, staticRenderFns } from "./SettingManager.vue?vue&type=template&id=be49ed00&scoped=true&"
import script from "./SettingManager.vue?vue&type=script&lang=js&"
export * from "./SettingManager.vue?vue&type=script&lang=js&"
import style0 from "./SettingManager.vue?vue&type=style&index=0&id=be49ed00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be49ed00",
  null
  
)

export default component.exports